import { render, staticRenderFns } from "./McrFormA2a.vue?vue&type=template&id=66866f32"
import script from "./McrFormA2a.vue?vue&type=script&lang=js"
export * from "./McrFormA2a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports